import {BettingAdBoostOddApiModel} from "./betting-ad.boost-odd.api-model";
import {BaseDomainModel} from "../../../../../infrastructure/models/base-domain-model";

export class BettingAdBoostOddDomainModel extends BaseDomainModel {
  apiModel: BettingAdBoostOddApiModel;

  constructor(apiModel: BettingAdBoostOddApiModel) {
    super(apiModel);

    this.unboosted = apiModel.unboosted;
    this.boosted = apiModel.boosted;
    this.boostPercentage = apiModel.boost_perc;
  }
}
